import { useMutation } from "@tanstack/react-query";
import { postApiAuthSignUp } from "Infrastructure/Api/Api";
import { HttpStatusCode } from "Infrastructure/Models/HttpStatusCodes";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting, getPath } from "Infrastructure/Utils/UrlUtils";
import { useNavigate } from "react-router-dom";

export function useSignUpMutation() {
	const navigate = useNavigate();
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const mutation = useMutation({
		mutationFn: postApiAuthSignUp,
		onSuccess: (data) => {
			// Invalidate and refetch
			if (data.status === HttpStatusCode.Created) {
				showSnackbar("Uživatel úspěšně vytvořen", "success");
				navigate(getPath(AppRouting.Users));
			} else if (data.status === HttpStatusCode.Conflict) {
				showSnackbar("Uživatel již existuje", "error");
			} else {
				showSnackbar(t(Resources.Errors.Error500), "error");
			}
		},
	});

	return mutation;
}
